<template>
<h2>TOP</h2>
</template>

<script>
export default {
  created(){
   
  console.log(process.env.VUE_APP_API_TEST)

  //this.$cognito.getuserData()
  }
}
</script>

<style>
h2 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue